module.exports = __webpack_public_path__ + "assets/img/translation-app-1.b149423d.png";